import React from 'react';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';

const CreditCardField = ({ input, meta }) => (
  <div className="col-sm form-group">
    <label
      htmlFor={input.name}
      className={
        meta.touched && meta.error ? 'label form-error__label' : 'label'
      }
    >
      Last four digits of your credit card
    </label>
    {meta.touched && meta.error && (
      <div className="form-error">{meta.error}</div>
    )}
    <input
      {...input}
      id={input.name}
      className="form-control form-control-lg w-25 mb-4 cancelfield"
      aria-label="Credit card last four numbers"
      type="tel"
      pattern="\d*"
      maxLength="4"
    />
  </div>
);
CreditCardField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
};

export default CreditCardField;
